import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Prices: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "PriceSpecification",
    "name": "PODO FEET Preisliste",
    "description": "Transparente Preise für professionelle Fusspflege-Dienstleistungen",
    "priceCurrency": "CHF",
    "offers": [
      {
        "@type": "Offer",
        "name": "Fusspflege",
        "description": "Nägel schneiden, feilen, Nagelfalz reinigen, Nagelhäutchen beseitigen, Hornhaut entfernen, Füsse eincremen",
        "price": "80",
        "priceCurrency": "CHF"
      },
      {
        "@type": "Offer",
        "name": "Tamponade",
        "description": "Eingewachsene Fussnägel, Druckstellen am Nagel",
        "price": "5",
        "priceCurrency": "CHF"
      },
      {
        "@type": "Offer",
        "name": "Klebespange",
        "description": "Eingerollte oder eingewachsene Nägel",
        "price": "25",
        "priceCurrency": "CHF"
      },
      {
        "@type": "Offer",
        "name": "Nagelaufbau/Nagelprothetik",
        "description": "Pilzbefallene Nägel, Nagelverlust",
        "price": "35",
        "priceCurrency": "CHF"
      },
      {
        "@type": "Offer",
        "name": "Nagellack, langhaftend",
        "price": "10",
        "priceCurrency": "CHF"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Preise Fusspflege | PODO FEET - Transparente Kosten für alle Leistungen"
        description="Faire und transparente Preise für professionelle Fusspflege bei PODO FEET. Fusspflege ab CHF 80.-, Tamponade CHF 5.-, Klebespange CHF 25.-, Nagelaufbau CHF 35.-"
        keywords="Fusspflege Preise, Kosten Fusspflege, CHF 80, Tamponade Preis, Klebespange Kosten, Nagelaufbau Preis, Altendorf Preisliste"
        url="https://podo-feet.ch/preise"
        structuredData={structuredData}
      />

      {/* Hero Banner */}
      <section className="relative bg-primary py-16">
        <div className="container-custom relative z-10">
          <h1 className="heading-1 text-white mb-4">Preisliste</h1>
          <div className="flex items-center text-white/90">
            <Link to="/" className="hover:text-white">Startseite</Link>
            <span className="mx-2">›</span>
            <span>Preise</span>
          </div>
        </div>
      </section>

      {/* Preisliste Übersicht */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="heading-2 text-primary mb-4">Meine Preise</h2>
              <p className="text-lg mb-6">
                Bei PODO FEET biete ich Ihnen transparente und faire Preise für meine professionellen Fusspflegeleistungen. 
                Nachfolgend finden Sie eine detaillierte Übersicht aller angebotenen Behandlungen und deren Kosten.
              </p>
            </div>

            {/* Preis-Kategorien */}
            <div className="space-y-10">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-primary text-white p-4">
                  <h3 className="text-xl font-bold">Preisliste</h3>
                </div>
                <div className="p-6">
                  <div className="space-y-8">
                    {/* Fusspflege */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Fusspflege</h4>
                          <p className="text-gray-600 text-sm">
                            Nägel schneiden, feilen, Nagelfalz reinigen, Nagelhäutchen beseitigen, Hornhaut entfernen, Füsse eincremen
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 80.-</span>
                      </div>
                    </div>

                    {/* Starke Hornhaut entfernen */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Starke Hornhaut entfernen</h4>
                        </div>
                        <span className="font-bold text-lg">nach Aufwand</span>
                      </div>
                    </div>

                    {/* Tamponade */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Tamponade</h4>
                          <p className="text-gray-600 text-sm">
                            Eingewachsene Fussnägel, Druckstellen am Nagel
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 5.-</span>
                      </div>
                    </div>

                    {/* Klebespange */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Klebespange</h4>
                          <p className="text-gray-600 text-sm">
                            Eingerollte oder eingewachsene Nägel
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 25.-</span>
                      </div>
                    </div>

                    {/* Nagelaufbau/Nagelprothetik */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Nagelaufbau/Nagelprothetik</h4>
                          <p className="text-gray-600 text-sm">
                            Pilzbefallene Nägel, Nagelverlust
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 35.-</span>
                      </div>
                    </div>

                    {/* Nagellack, langhaftend */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Nagellack, langhaftend</h4>
                          <p className="text-gray-600 text-sm">
                            Flip-Flop Schuhe mitnehmen
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 10.-</span>
                      </div>
                    </div>

                    {/* Nagellack entfernen und neu malen */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Nagellack entfernen und neu malen</h4>
                          <p className="text-gray-600 text-sm">
                            Flip-Flop Schuhe mitnehmen
                          </p>
                        </div>
                        <span className="font-bold text-lg">CHF 15.-</span>
                      </div>
                    </div>

                    {/* Hühneraugen und Schrunden entfernen */}
                    <div className="border-b border-gray-200 pb-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h4 className="text-lg font-semibold text-primary">Hühneraugen und Schrunden entfernen</h4>
                        </div>
                        <span className="font-bold text-lg">nach Aufwand</span>
                      </div>
                    </div>
                  </div>

                  {/* Zusätzliche Informationen */}
                  <div className="mt-10 space-y-6">
                    <div className="bg-bgLight p-5 rounded-lg">
                      <h4 className="text-lg font-semibold text-primary mb-2">Gutscheine</h4>
                      <p>
                        Gutscheine erhältlich auf Anfrage. Gerne erstelle ich Ihnen einen Gutschein mit dem gewünschten Guthaben.
                      </p>
                    </div>

                    <div className="bg-bgLight p-5 rounded-lg">
                      <h4 className="text-lg font-semibold text-primary mb-2">Pflegeprodukte</h4>
                      <p>
                        In meiner Praxis biete ich ausgewählte Pflegeprodukte von Fusspunkt an. Sprechen Sie mich gerne an, ich berate Sie individuell.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            

            
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-primary py-16 mt-16">
        <div className="container-custom text-center">
          <h2 className="heading-2 text-white mb-6">Fragen zu meinen Preisen?</h2>
          <p className="text-white/90 max-w-3xl mx-auto mb-8">
            Sie haben Fragen zu den Preisen oder möchten einen Termin vereinbaren? 
            Kontaktieren Sie mich gerne persönlich. Ich berate Sie individuell zu Ihren Bedürfnissen.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/kontakt" className="btn bg-white text-primary hover:bg-lightGreen">
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Prices; 